import {
  CONTENT_SENSITIVITY,
  getContentSensitivityLabelDescription,
  normalizeContentSensitivityReason,
} from 'src/data/generation';
import { CHANNEL } from 'src/data/channel';
import { getAssetChannel } from 'src/data/asset';
import { getGoogleContentValidationDetailsPerReason } from './googleSensitiveInfoConverter';

// see https://docs.google.com/spreadsheets/d/1CcHV33CFfh_SIXplGOXSju_Q7suXU6m-uKt_c7RlzQI/edit?usp=sharing
const isGPT3Violation = (reason) => {
  return /The content of this variation may be (sensitive|unsafe)/i.test(reason);
};

const getTitle = (policyTitle, isFBViolation, isGoogleViolation) => {
  if (policyTitle) {
    return isGoogleViolation
      ? 'Google policy'
      : isFBViolation
      ? 'Facebook policy'
      : 'Channel policy';
  }
  return 'Content safety';
};

export const getContentSensitivityInfo = (policyTitle, sensitivity, assetType) => {
  const label = sensitivity?.label || '';
  const reason = sensitivity?.reason;
  const labelDesc = getContentSensitivityLabelDescription(label || '');
  const normalReason = normalizeContentSensitivityReason(reason || '');
  const channel = getAssetChannel(assetType);

  const isFBViolation =
    labelDesc !== CONTENT_SENSITIVITY.safe &&
    !isGPT3Violation(normalReason) &&
    channel === CHANNEL.facebook;

  const isGoogleViolation =
    labelDesc !== CONTENT_SENSITIVITY.safe &&
    !isGPT3Violation(normalReason) &&
    channel === CHANNEL.google;

  const title = getTitle(policyTitle, isFBViolation, isGoogleViolation);
  let reasonDetails = sensitivity?.reasonDetails;
  let reasonTitle = ''; // default when neither isGoogleViolation nor isFBViolation
  let learnMoreLink = '';
  let reasonDesc = normalReason;

  if (isGoogleViolation) {
    const googleDetails = getGoogleContentValidationDetailsPerReason(sensitivity);
    reasonTitle = googleDetails.reasonTitle;
    reasonDesc = googleDetails.reasonDescription;
    reasonDetails = googleDetails.reasonDetails;
    learnMoreLink = googleDetails.learnMoreLink;
  } else if (isFBViolation) {
    reasonTitle = 'Possible Facebook policy violation:\n';
  }

  return { title, reasonTitle, reasonDesc, reasonDetails, learnMoreLink, labelDesc };
};
